// extracted by mini-css-extract-plugin
export default {"-large":"aGbekRQpHXNijwNOKmue","container":"OafUwSByDpQrxA1MQai3"};